import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext } from "react";
import { useInitReportProductDo } from "hooks/reportProductDo/useInitReportProductDo";
var ReportProductDoInitContext = /*#__PURE__*/ createContext(undefined);
export var ReportProductDoInitProvider = function(param) {
    var children = param.children;
    var contextValue = useInitReportProductDo();
    return /*#__PURE__*/ _jsx(ReportProductDoInitContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useReportProductDoInitContext = function() {
    var context = useContext(ReportProductDoInitContext);
    if (!context) {
        throw new Error("useReportProductDoInitContext must be used within a ??");
    }
    return context;
};
